export const MARKET_WIDE_BADGE_TOOLTIP =
  'This section shows market-wide data. Your filters are not applied here.';

export const VERIFIED_LOCK_BADGE_TOOLTIP =
  'This data is available only for verified markets (blue checkmark in search). It is not available for submarkets or custom markets.';
